module.exports = __webpack_public_path__ + "img/134.ecc0e4ea.jpg";